export default __webpack_public_path__ + "static/media/logIn.a42d8a8d.jpg";